export default __webpack_public_path__ + "static/media/notification.64cf5cf5.svg";